import { render, staticRenderFns } from "./Easter_foodItem.vue?vue&type=template&id=6ac267be&scoped=true"
import script from "./Easter_foodItem.vue?vue&type=script&lang=ts"
export * from "./Easter_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./Easter_foodItem.vue?vue&type=style&index=0&id=6ac267be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac267be",
  null
  
)

export default component.exports